DJ.addBehavior('columns-text', '.columns-text', {
  attach: function(context, settings, behavior) {
    var columns = jQuery(this).find('ul li').length;
    var className = '';
    switch (columns) {
      case 2:
        className = 'col-50';
        break;
      case 3:
        className = 'col-33';
        break;
      case 4:
        className = 'col-25';
        break;
      default:
        className = '';
        break;
    }
    jQuery(this).find('ul li').addClass(className);
  },

  detach: function(context, settings) {}
});
